// extracted by mini-css-extract-plugin
export var divider = "_g8-7";
export var itemsToggle = "_g8-8";
export var mergeModal = "_g8-1";
export var optionCard = "_g8-4";
export var radioGroup = "_g8-6";
export var radioOption = "_g8-0";
export var selected = "_g8-5";
export var shipmentOptions = "_g8-2";
export var tableOptions = "_g8-3";